// Import Routes
import * as ROUTES from "../routes";

import TEAMS from '@/modules/workforce/views/team/teams'
import TEAM from '@/modules/workforce/views/team/team'
import ADMINS from '@/modules/workforce/views/admins'
import AUDIT from '@/modules/workforce/views/audits.vue'

const routes = [
    {
        path: ROUTES.TEAMS,
        name: "teams",
        component: TEAMS,
        meta: {
            title: "Dtunes Work Force",
            layout: "private",
            requiresAuth: true,
            nav: 'Workforce',
            permissions: ['can_view_admins']
        }
    },
    {
        path: ROUTES.TEAM,
        name: "team",
        component: TEAM,
        meta: {
            title: "Dtunes Team",
            layout: "private",
            requiresAuth: true,
            nav: 'Workforce',
            permissions: ['can_view_admins']
        }
    },
    {
        path: ROUTES.ADMINS,
        name: "Administrator",
        component: ADMINS,
        meta: {
            title: "Dtunes Administrators",
            layout: "private",
            requiresAuth: true,
            nav: 'Workforce',
            permissions: ['can_view_admins']
        }
    },
    {
        path: ROUTES.AUDIT,
        name: "Audit Logs",
        component: AUDIT,
        meta: {
            title: "Dtunes AUDITS",
            layout: "private",
            requiresAuth: true,
            nav: 'Workforce',
            permissions: ['can_view_admins']
        }
    },
]

export default routes;